import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { PatientQueueSettingsType } from '../settings/interfaces/patientQueueSettings'
import { ServerUrlService } from './server-url.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class PatientQueueSettingsService {
  private headers: any
  constructor(private httpClient: HttpClient, private serverUrl: ServerUrlService) {
    this.headers = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  }

  getPatientQueueSettings(): Observable<PatientQueueSettingsType> {
    const url = this.serverUrl.getUrl()
    return this.httpClient.get<PatientQueueSettingsType>(url + '/patient-queue-settings')
  }

  insertPatientQueueSettings(formData: PatientQueueSettingsType) {
    this.httpClient
      .post(
        `${this.serverUrl.getUrl()}/patient-queue-settings`,
        JSON.stringify(formData),
        this.headers
      )
      .subscribe((res) => {})
  }

  updatePatientQueueSettings(formData: PatientQueueSettingsType) {
    this.httpClient
      .put(
        `${this.serverUrl.getUrl()}/patient-queue-settings`,
        JSON.stringify(formData),
        this.headers
      )
      .subscribe((res) => {})
  }
}
